import { apiService } from './index';

// Inport types
import { ISelectType } from '../shared/types/select-type';

export const asyncGetCountries = async (): Promise<ISelectType[]> => {
    const { items }: any = await apiService.get(`/api/country`);
    return items || [];
};
